<template>
  <div class="itemapresentacao">
    <router-link :to="'apresentacoes/' + apr.codigo">
      <div class="convite-item" v-bind:class="corStatusComputado">
        <b style="font-size: 1.1em">{{ apr.nome }}</b><br />
        Organizado por {{ apr.organizador }}<br />
        <span v-if="apr.data && !apr.dataprecisao">{{ new Date(apr.data.seconds * 1000) | moment("DD/MM/YYYY")}}</span>
        <span v-if="apr.data && apr.dataprecisao === 'mes'">{{ new Date(apr.data.seconds * 1000) | moment("MM/YYYY")}}</span>
        <span v-if="apr.data && apr.dataprecisao === 'ano'">{{ new Date(apr.data.seconds * 1000) | moment("YYYY")}}</span>
        <span v-if="!apr.data">Data a ser definida</span>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ItemApresentacao',
  props: {
    apr: Object
  },
  computed: {
    corStatusComputado: function () {
      const dataAtual = new Date()
      if (!this.apr.data || dataAtual < new Date(this.apr.data.seconds * 1000)) return { blue: true }
      if (dataAtual > new Date(this.apr.data.seconds * 1000)) return { gray: true }
      return { gray: true }
    }
  }
}
</script>

<style scoped>
a {
  color: inherit; /* blue colors for links too */
  text-decoration: inherit; /* no underline */
}
.convite-item {
  color: white;
  padding: 10px;
  margin-top: 10px;
  background: rgb(26,87,213);
  background: linear-gradient(0deg, rgba(26,87,213,1) 0%, rgba(48,130,204,1) 100%);
  border-radius:6px;
  -moz-border-radius:6px;
  -webkit-border-radius:6px;
}

.gray {
  background: rgb(64, 64, 64);
  background: linear-gradient(0deg, rgb(64, 64, 64) 0%, rgb(100, 100, 100) 100%);
}

.blue {
  background: rgb(26,87,213);
  background: linear-gradient(0deg, rgba(26,87,213,1) 0%, rgba(48,130,204,1) 100%);
}
</style>
